import React, { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid2"; // Import Grid2
import { Box, Button, Typography } from "@mui/material";
import { get } from "../../../services/apiService";
import ScreenLoader from "../../common/ScreenLoader";
import i18next from "i18next";
import { useAuth } from "../../../hooks/useAuth";

const ThemeSection = ({ onThemeContinue, screenWidth }) => {
  const { currentLang } = useAuth();
  const [selectedThemeIndex, setSelectedThemeIndex] = useState(null);
  const [selectedTheme, setSelectedTheme] = useState({});

  const [isLoading, setIsLoading] = useState(true);

  const [themes, setThemes] = useState([]);
  // const [selectedThemeObject, setSelectedThemeIndex]
  // const themes = [
  //   { label: "Theme 1", color: "#32C3A5" },
  //   { label: "Theme 2", color: "#42D17E" },
  //   { label: "Theme 3", color: "#49A2DF" },
  //   { label: "Theme 4", color: "#A569BC" },
  //   { label: "Theme 5", color: "#2DAA92" },
  //   { label: "Theme 6", color: "#3DB671" },
  //   { label: "Theme 7", color: "#3F8DC0" },
  //   { label: "Theme 8", color: "#9A57B5" },
  //   { label: "Theme 9", color: "#F2CA27" },
  //   { label: "Theme 10", color: "#EDA160" },
  //   { label: "Theme 11", color: "#E35A4E" },
  //   { label: "Theme 12", color: "#B3BEBE" },
  // ];

  const handleThemeClick = (index, theme) => {
    setSelectedThemeIndex(index); // Update selected theme index
    setSelectedTheme(theme);
  };

  const userId = sessionStorage.getItem("userId");

  const onLoading = useCallback((isLoading) => {
    setIsLoading(isLoading);
  }, []); // onLoading is stable as it has no dependencies

  const fetchUserTheme = useCallback(
    async (allThemes) => {
      if (userId) {
        const response = await get(`users/${userId}/theme`, {}, onLoading);
        const userTheme = {
          id: response.data.id,
          color: response.data.primaryColor,
          label: response.data.themeName,
        };
        const requiredTheme = allThemes.find(
          (theme) =>
            theme.label.toLowerCase() === userTheme.label.toLowerCase(),
        );
        if (requiredTheme) {
          setSelectedTheme(userTheme);
          setSelectedThemeIndex(requiredTheme.id - 1);
        }
      }
    },
    [userId, onLoading],
  );

  const fetchThemes = useCallback(async () => {
    console.log("fetch themes api is called");
    const response = await get(
      `theme?order=ASC&page=1&take=20`,
      {
        headers: {
          "Accept-Language": currentLang,
        },
      },
      onLoading,
    );
    if (response.status === 200) {
      const themes = response?.data?.data?.map((theme) => {
        return {
          id: theme.id,
          label: theme.themeName,
          color: theme.primaryColor,
        };
      });
      setThemes(themes);
      fetchUserTheme(themes);
    }
  }, [currentLang, fetchUserTheme, onLoading]);

  useEffect(() => {
    fetchThemes();
  }, [fetchThemes]);

  return (
    <Grid container spacing={2} sx={{ padding: "1%", marginTop: "-4%" }}>
      <Grid
        size={12}
        sx={{ textAlign: "center" }}
        onClick={(event) => {
          setSelectedThemeIndex(null);
          event.stopPropagation();
        }}
      >
        <Typography
          sx={{
            fontSize: screenWidth > 600 ? "40px" : "30px",
            fontFamily: "Tajawal-Bold",
            fontWeight: screenWidth > 600 ? "700" : "400",
          }}
        >
          {i18next.t("THEME_SELECTION_PAGE_HEADING_1")}
        </Typography>
        <Typography
          sx={{
            fontSize: screenWidth > 600 ? "24px" : "20px",
            fontFamily: "Tajawal-Regular",
            fontWeight: "400",
            marginBottom: "3%",
          }}
        >
          {i18next.t("THEME_SELECTION_PAGE_HEADING_2")}
        </Typography>
      </Grid>

      {/* Theme boxes */}
      <Grid
        container
        spacing={2}
        display="flex"
        justifyContent="center" // Center horizontally
        alignItems="center" // Center vertically
        sx={{
          minHeight: "100vh", // Ensure it takes the full viewport height for vertical centering
          maxWidth: "1440px",
          margin: "auto",
          // paddingLeft:
          //   screenWidth > 2000
          //     ? "26%"
          //     : screenWidth > 1400
          //       ? "20%"
          //       : screenWidth > 900
          //         ? "18%"
          //         : "4%",
          // paddingRight:
          //   screenWidth > 2000
          //     ? "18%"
          //     : screenWidth > 1400
          //       ? "20%"
          //       : screenWidth > 900
          //         ? "18%"
          //         : "4%",
          width: "100%",
        }}
      >
        {isLoading ? (
          <ScreenLoader />
        ) : themes.length > 0 ? (
          themes.map((theme, index) => (
            <Grid
              item // Use `item` instead of `size` to prevent conflicts
              size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 3 }} // Responsive design
              key={index}
            >
              <Box
                onClick={() => handleThemeClick(index, theme)}
                sx={{
                  backgroundColor: theme.color,
                  color: "white",
                  height: "250px",
                  width: "100%", // Full width for responsive design
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "20px",
                  fontWeight: selectedThemeIndex === index ? 900 : 100,
                  borderRadius: "8px",
                  cursor: "pointer",
                  boxShadow:
                    selectedThemeIndex === index
                      ? "0 0 15px rgba(0, 0, 0, 0.3)"
                      : "none", // Highlight the selected box
                  transform:
                    selectedThemeIndex === index ? "scale(1.09)" : "scale(1)", // Slightly enlarge selected box
                }}
              >
                {`${i18next.t("THEME_TEXT")} ${index + 1}`}
              </Box>
            </Grid>
          ))
        ) : (
          <Box>
            <Typography> No themes are available.</Typography>
          </Box>
        )}
        {(selectedThemeIndex || selectedThemeIndex === 0) && (
          <Button
            sx={{
              color: "white",
              marginTop: "1%",
              marginBottom: "5%",
              width: screenWidth > 600 ? "30%" : "50%",
              fontSize: screenWidth > 600 ? "32px" : "24px",
              fontWeight: 700,
              borderTopLeftRadius: "15px",
              borderBottomRightRadius: "15px",
              background:
                "linear-gradient(to right, #004D8A, #02599C, #0886E1, #0A91F2)",
              fontFamily: "Tajawal-Bold",
            }}
            onClick={() => onThemeContinue(selectedTheme)}
          >
            {i18next.t("THEME_SELECTION_PAGE_BUTTON_LABEL_CONTINUE")}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default ThemeSection;
